import * as React from 'react';
import s from './developerPageTopSection.scss';
import StarFilled from 'wix-ui-icons-common/StarFilled';
import { Heading, Text, Avatar, Box } from 'wix-style-react';
import { BackButton } from '../../back-button';
import { composer } from '../../../component-decorators/composer';
import { getClientImageURL } from '../../../common/getClientImageURL';
export var DeveloperPageTopSection = composer()
    .withTranslation()
    .withMarketplaceStore()
    .withExperiments()
    .compose(function (_a) {
    var icon = _a.icon, appsCount = _a.appsCount, name = _a.name, averageRating = _a.averageRating, marketplaceStore = _a.marketplaceStore, t = _a.t;
    var shouldShowBackButton = marketplaceStore.prevRoute &&
        marketplaceStore.route.referral !== 'back_button' &&
        marketplaceStore.route.referral !== 'menu_navigation';
    return (React.createElement(React.Fragment, null,
        shouldShowBackButton && React.createElement(BackButton, { skinColor: 'dark' }),
        React.createElement("section", { className: s.companyHeader },
            React.createElement(Box, { marginTop: '6px' },
                React.createElement(Avatar, { size: 'size60', className: s.avatar, imgProps: {
                        className: s.logo,
                        src: getClientImageURL(icon, {
                            toHeight: 60,
                            toWidth: 60,
                        }),
                        alt: name + " company logo",
                    } })),
            React.createElement("span", { className: s.infoContainer },
                React.createElement(Heading, { appearance: "H1", className: s.appName }, name),
                React.createElement("div", { className: s.rating },
                    React.createElement(StarFilled, { className: s.star }),
                    React.createElement(Text, { weight: "bold", size: "medium", className: s.ratingText },
                        React.createElement("span", { className: s.ratingNumber }, averageRating + " "),
                        appsCount === 1
                            ? t('developer.page.rating.info.single.app', {
                                appsCount: appsCount,
                            })
                            : t('developer.page.rating.info', {
                                appsCount: appsCount,
                            })))))));
});
//# sourceMappingURL=developer-page-top-section.js.map